import { render, staticRenderFns } from "./tasks-item-status.vue?vue&type=template&id=1170230c"
import script from "./tasks-item-status.vue?vue&type=script&lang=js"
export * from "./tasks-item-status.vue?vue&type=script&lang=js"
import style0 from "./tasks-item-status.vue?vue&type=style&index=0&id=1170230c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports